import { render } from "./SubProjectPage.vue?vue&type=template&id=511ee65c&ts=true"
import script from "./SubProjectPage.ts?vue&type=script&lang=ts&external"
export * from "./SubProjectPage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__